{
  "notices": [
    {
      "severity": "warning",
      "title": "Virginia Launch Issues",
      "message": "We are currently experiencing issues launching sessions in Virginia. If you're having trouble launching, please select another location. If the problem persists, contact support at https://enercalc.com/contact-us/.",
      "datetime": "2026-08-13T15:35:52Z"
    }
  ]
}
